<template>
  <div class="page-container">
    <div>
      <section class="page-header">
        <h2 class="font-weight-bold">
          Relatórios
        </h2>
      </section>

      <div class="separator-line"></div>
      <section class="sub-header">
        <p class="color-green-2 p3">
          Visualize e gere relatórios detalhados para acompanhar informações importantes de forma clara e organizada.
        </p>
      </section>
    </div>
    <section>
      <div class="card-container">
        <CustomInfoCard
          class="deck deck-margin"
          v-for="card in getCards"
          :key="card.id"
          :onCardClick="() => onClickCard(card)"
          :headerIcon="card.headerIcon"
          :title="card.header"
          :description="card.description"
          :icon="card.icon"
          :featureName="card.featureName"
        />
      </div>
    </section>
  </div>
</template>

<script>
import CustomInfoCard from "../../../components/custom-info-card/CustomInfoCard.vue";
import RoutesPaths from "../../../router/router-structure/routes-paths";
import { isMobile } from "../../../utils/mobile/mobile";

export default {
  components: {
    CustomInfoCard,
  },
  computed: {
    getCards: () => {
      let cards = [
      {
        id: 0,
        icon: "MDI-account-eye.svg",
        header: "Visualizações do Portal",
        description:
          "Faça o download do relatório de visualizações com base no período selecionado",
        route: RoutesPaths.reports.rootName(),
        showMobile: true,
        featureName: "HOME_CARD_CONTENT_REPORTS",
      },
      {
          id: 0,
          icon: "MDI-notebook-check-outline.svg",
          header: "Atualização Guia médico",
          description:
            "Acesse o relatório de atualização do Guia médico",
          route: RoutesPaths.medicalGuideManagement.rootName(),
          showMobile: true,
          featureName: "HOME_CARD_CONTENT_MANAGEMENT_MEDICAL_GUIDE",
        },
        {
          id: 1,
          icon: "call-quality.svg",
          header: "Referências",
          description: "Consulte dados dos contatos de referência registrados pelo cooperado.",
          route: RoutesPaths.contactEmergencyReport.rootName(),
          showMobile: true,
          featureName: "HOME_CARD_CONTACT_EMERGENCY_REPORT"
        }
      ];
      if (isMobile()) {
        return cards.filter((c) => c.showMobile);
      }
      return cards;
    },
  },
  methods: {
    isMobile: isMobile,
    onClickCard({ route, link }) {
      if (link) {
        window.open(link, "_blank");
      } else if (route) this.$router.push(route);
    },
  },
};
</script>

<style lang="scss" scoped>
.deck-margin {
  margin: 2rem;
}

.page-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.page-header {
  text-align: center;
}

.sub-header {
  max-width: 83rem;
  margin: 0 auto;
  margin-top: 1.5rem;
  text-align: center;
}

.card-container {
  max-width: 100rem;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @include media-breakpoint-up(xs) {
    justify-content: center;
  }

  @include media-breakpoint-up(md) {
    justify-content: center;
  }
}

.pointer {
  cursor: pointer;
}
</style>

